import { API_HOST, axiosInstance, axiosRequestWithAuth } from "../constants/server.constant";

const fetchWebhooks = async (userId) => {
    return await axiosInstance.get(API_HOST + "/" + userId + "/slack", axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const updateWebhook = async (userId, slackWebhook) => {
    return await axiosInstance.patch(API_HOST + "/" + userId + "/slack", slackWebhook, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

const deleteWebhook = async (userId, slackId) => {
    return await axiosInstance.delete(API_HOST + "/" + userId + "/slack/" + slackId, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return Promise.reject(error);
    });
};

export const SlackService = {
    fetchWebhooks,
    updateWebhook,
    deleteWebhook,
};